import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable, Subscriber, Subscription } from "rxjs";
export interface ITransaction {
    user: string
    tokensBought: string
    amountPaid: string
    usdEq: string
    isNativeToken: boolean
    timestamp: string
    projectName: string
    slug: string
    logo: string
    chain: string
    transactionHash: string
    explorerUrl: string
    stableCoin: any
}

export interface ITransactionAPiResponse {
    data: ITransaction
}

export interface Project {
    name: string
    ticker: string
    logo: string
}

enum EVENTS {
    TOKENS_BOUGHT = "TokensBought",
    TOKENS_BOUGHT_AND_STAKED = "TokenBoughtAndStaked",
    TOKENS_CLAIMED = "TokensClaimed",
    TOKENS_CLAIMED_AND_STAKED = "TokensClaimedAndStaked"
}

const CLAIM_EVENTS = [EVENTS.TOKENS_CLAIMED, EVENTS.TOKENS_CLAIMED_AND_STAKED]


interface NotificationResponse {
    event: string;
    data: {
        user: string;
        tokensBought: string;
        amountPaid: string;
        usdEq: string;
        isNativeToken: boolean;
        timestamp: string;
        projectName: string;
        slug: string;
        chain: string;
        transactionHash: string;
        explorerUrl: string;
        logo: string;
        // for claim events
        amount: string;
        blockNumber: string;
    };
    timestamp: string;
}

@Injectable({
    providedIn: "root"
})

export class PresaleTransacationService {
    private eventSource: EventSource | null = null;
    private subscriptions: Subscription = {} as Subscription;
    transactions: ITransaction[] = [];
    url = environment.transactionUrl
    sseUrl = environment.sseUrl
    constructor(private http: HttpClient) {

    }

    async getTransactions(limit: number = 10) {
        // no need to create url and slug dynamic. We are using it for only one purpose here
        return this.http.get(this.url)
    }

    setAllTransaction(transactions: ITransactionAPiResponse[]) {
        const filteredTransaction = transactions.map((item) => item.data).filter((item) => !!item.usdEq) // filtering out corrupt entries!
        this.transactions = filteredTransaction
    }

    startListner() {
        if (this.sseUrl != '' && environment.production) {
            this.subscriptions = this.connectToServerSentEvents(this.sseUrl).subscribe({
                next: (data: any) => {
                    if (!data?.data || data.data === 'ping') return;
                    let item: NotificationResponse;
                    try {
                        item = JSON.parse(data.data);
                    } catch {
                        return;
                    }
                    const transaction_item: ITransaction = { ...item.data } as any
                    console.log({ transaction_item });
                    const new_item = [{ ...transaction_item }];
                    this.transactions = [...new_item, ...this.transactions];

                },
                error: (error: any) => {
                    console.error('Notification Error:', error);
                    this.destroySubscription();
                },
            });
        }
    }

    connectToServerSentEvents(url: string): Observable<Event> {
        return new Observable((subscriber: Subscriber<Event>) => {
            this.eventSource = new EventSource(url);

            this.eventSource.onerror = (error: any) => {
                subscriber.error(error);
            };

            this.eventSource.onmessage = (event: MessageEvent) => {
                subscriber.next(event);
            };

            return () => {
                this.closeEventSource();
                subscriber.complete();
            };
        });

    }
    destroySubscription() {
        if (Object.keys(this.subscriptions).length) this.subscriptions.unsubscribe()
    }

    closeEventSource(): void {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
            this.subscriptions.unsubscribe()
        }
    }

    isClaimEvents(event: string): Boolean {
        return CLAIM_EVENTS.includes(event as EVENTS.TOKENS_BOUGHT)
    }

    getUsdEqAmount(data: NotificationResponse) {
        if (!this.isClaimEvents(data.event) && data.data.isNativeToken) {
            return data.data.amountPaid
        }
        return data.data.usdEq
    }

}